import { View } from './view'

export const Interview = View
